import {User, LogOut} from 'lucide-react'
import { useAuth } from '../hooks/useAuth'

export default function AuthButton() {
  const { user, isAuthenticated, isLoading, signIn, signOut } = useAuth()

  if (isLoading) {
    return (
      <button
        disabled
        className="px-4 py-2 bg-gray-300 text-gray-600 rounded-lg font-medium cursor-not-allowed"
      >
        Loading...
      </button>
    )
  }

  if (isAuthenticated && user) {
    return (
      <div className="flex items-center gap-3">
        <div className="hidden sm:flex items-center gap-2 px-3 py-1 bg-green-50 rounded-lg border border-green-200">
          <User className="w-4 h-4 text-green-600" />
          <span className="text-sm font-medium text-gray-700">{user.userName}</span>
        </div>
        <button
          onClick={signOut}
          className="flex items-center gap-2 px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg font-medium transition-colors"
        >
          <LogOut className="w-4 h-4" />
          <span className="hidden sm:inline">Sign Out</span>
        </button>
      </div>
    )
  }

  return (
    <button
      onClick={signIn}
      className="flex items-center gap-2 px-6 py-2 bg-gradient-to-r from-green-600 to-blue-600 hover:from-green-700 hover:to-blue-700 text-white rounded-lg font-medium transition-all shadow-md hover:shadow-lg"
    >
      <User className="w-4 h-4" />
      Sign In
    </button>
  )
}